import { Component, input } from '@angular/core';
import { ResolveLibModule } from '../resolve-lib.module';

@Component({
  selector: 'lib-new-feature-banner',
  imports: [
    ResolveLibModule
  ],
  templateUrl: './new-feature-banner.component.html',
  styleUrl: './new-feature-banner.component.scss'
})
export class NewFeatureBannerComponent {
  iconName = input<string>();
}
